import React from "react";

/** Painel de analytics de download de certificados. */
export const CertAnalyticsPanel = ({ certAnalytics, onReload }) => (
  <div className="bg-white border border-slate-200 rounded-xl overflow-hidden mb-6" data-testid="admin-analytics-panel">
    <div className="p-4 border-b border-slate-200 flex items-center justify-between">
      <h2 className="font-display font-bold text-lg text-[#0B2B62]">Downloads de Certificado (30 dias)</h2>
      <button onClick={onReload} className="text-xs px-2.5 py-1 border border-slate-200 rounded-md hover:bg-slate-50">Atualizar</button>
    </div>
    {!certAnalytics ? (
      <div className="p-10 text-center text-slate-500 text-sm">Carregando…</div>
    ) : (
      <>
        <div className="p-4 border-b border-slate-100 bg-slate-50 text-xs text-slate-600 flex flex-wrap items-center gap-x-6 gap-y-1">
          <div><b className="text-slate-900">{certAnalytics.total_30d}</b> download(s) nos últimos 30 dias</div>
          <div><b className="text-slate-900">{certAnalytics.unique_clinics}</b> unidade(s) engajada(s)</div>
        </div>
        {certAnalytics.by_day.length > 0 && (
          <div className="p-4 border-b border-slate-100" data-testid="analytics-daychart">
            <div className="text-[11px] font-semibold uppercase tracking-widest text-slate-500 mb-2">Por dia</div>
            <div className="flex items-end gap-1 h-24">
              {certAnalytics.by_day.map((d) => {
                const max = Math.max(...certAnalytics.by_day.map((x) => x.count), 1);
                const h = Math.max(4, Math.round((d.count / max) * 88));
                return (
                  <div key={d.date} className="flex flex-col items-center gap-1 flex-1 min-w-0" title={`${d.date}: ${d.count}`}>
                    <div style={{ height: `${h}px` }} className="w-full bg-[#0B2B62] rounded-t" />
                    <div className="text-[9px] text-slate-500 truncate">{d.date.slice(5)}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
        {certAnalytics.by_clinic.length === 0 ? (
          <div className="p-10 text-center text-slate-500 text-sm">Nenhum download ainda.</div>
        ) : (
          <div className="divide-y divide-slate-100">
            {certAnalytics.by_clinic.map((c) => (
              <div key={c.clinic_id} className="p-4 flex items-center justify-between hover:bg-slate-50" data-testid={`analytics-clinic-${c.clinic_id}`}>
                <div className="min-w-0">
                  <div className="font-display font-semibold text-[#0B2B62] truncate">{c.clinic_name}</div>
                  <div className="text-xs text-slate-500">Último download: {c.last ? new Date(c.last).toLocaleString("pt-BR") : "—"}</div>
                </div>
                <div className="text-xs font-bold uppercase tracking-widest px-2.5 py-1 rounded-full bg-slate-100 text-slate-700">
                  {c.count} download{c.count > 1 ? "s" : ""}
                </div>
              </div>
            ))}
          </div>
        )}
      </>
    )}
  </div>
);

export default CertAnalyticsPanel;
